import { stringify } from "query-string"

import { dhFoodsMain } from "./api"

const contractEndpoint = "/contract"
const marketplaceEndpoint = "/marketplace/management"
const publicMarketplaceEndpoint = "/marketplace"

const toQuery = queries =>
  stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

export const updateMarketplaceContractAdmin = async (contractId, data) => {
  const response =
    await dhFoodsMain.patch(
      `${contractEndpoint}/marketplace?${toQuery({ contractId })}`,
      data
    )

  return response.data
}

export const getMarketplaceContractReportAdmin = async (contractId, queries = {}) => {
  const response =
    await dhFoodsMain.get(
      `${contractEndpoint}/marketplace/report?${toQuery({ contractId, ...queries })}`
    )

  return response.data
}

export const getMarketplaceWithdrawalsAdmin = async (contractId, queries = {}) => {
  const response =
    await dhFoodsMain.get(
      `/withdrawal?${toQuery({ ...(contractId ? { contractId } : {}), limit: 20, ...queries })}`
    )

  return response.data
}

export const createMarketplaceWithdrawalHaghighiPaymentAdmin = async (contractId, withdrawalId) => {
  const response =
    await dhFoodsMain.post(
      `/withdrawal/${withdrawalId}/payment/haghighi?${toQuery({ ...(contractId ? { contractId } : {}) })}`
    )

  return response.data
}

export const getMarketplaceManagedContent = async () => {
  const response = await dhFoodsMain.get(`${marketplaceEndpoint}/content`)

  return response.data
}

export const createMarketplaceManagedContent = async data => {
  const response = await dhFoodsMain.post(`${marketplaceEndpoint}/content`, data)

  return response.data
}

export const updateMarketplaceManagedContent = async (contentId, data) => {
  const response =
    await dhFoodsMain.patch(`${marketplaceEndpoint}/content/${contentId}`, data)

  return response.data
}

export const deleteMarketplaceManagedContent = async contentId => {
  await dhFoodsMain.delete(`${marketplaceEndpoint}/content/${contentId}`)
}

export const getMarketplaceDecorationLayout = async () => {
  const response = await dhFoodsMain.get(`${marketplaceEndpoint}/decoration-layout`)

  return response.data
}

export const updateMarketplaceDecorationLayout = async data => {
  const response = await dhFoodsMain.patch(`${marketplaceEndpoint}/decoration-layout`, data)

  return response.data
}

export const getLayout = getMarketplaceDecorationLayout

export const changeLayout = updateMarketplaceDecorationLayout

export const getAllFoods = async queries => {
  const response =
    await dhFoodsMain.get(
      `${publicMarketplaceEndpoint}/products?${toQuery({ limit: 100, ...queries })}`
    )

  return response.data?.data || []
}

export const getCategories = async queries => {
  const response =
    await dhFoodsMain.get(
      `${publicMarketplaceEndpoint}/categories?${toQuery(queries)}`
    )

  return response.data?.data || []
}
